import React, { useState } from "react";
import { Image } from "react-bootstrap";
import IconPlus from "../../../assets/icon-plus.svg";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { VIDEO_FORMATS } from "../../../constant";
import { VideoPlayerModal } from "../modal/videoPlayerModal";
import AttachmentIcon from "../../../assets/attachment-red-icon.svg";

export function DisplayPopUpAttachments({
  onTogglePopUp = () => {},
  onRemoveFile = () => {},
  isAgendaAttachment,
  filesArr = [],
  removeRequired = true,
  addAttchementRequired = true,
  classes = "",
  buttonTitle
}) {
  const [state, setState] = useState({ popUp: false, item: null });
  const [showVideoModal, setShowVideoModal] = useState(false);
  const [videoUrl, setVideoUrl] = useState(null);
  const [videoTitle, setVideoTitle] = useState(null);

  const onToogleRemovePopUp = value => {
    setState(prevState => {
      return { popUp: !prevState.popUp, item: value };
    });
  };

  const onRemove = () => {
    onRemoveFile(state.item);
    onToogleRemovePopUp(state.item);
  };

  const showVideoPlayerModal = () => {
    return (
      <VideoPlayerModal
        showVideoModal={showVideoModal}
        url={videoUrl}
        videoTitle={videoTitle}
        onClose={() => {
          setShowVideoModal(false);
          setVideoUrl(null);
          setVideoTitle(null);
        }}
      />
    );
  };

  return (
    <section className={`display-attachments-section ${classes}`}>
      <ConfirmationComponent
        show={state.popUp}
        modalClass={"confirmation-modal"}
        saveHandler={onRemove}
        closeHandler={onToogleRemovePopUp}
        content={"Are you sure you want to do this?"}
      />
      {addAttchementRequired ? (
        <div
          className={`add-files ${buttonTitle ? "add-attachment" : ""}`}
          onClick={() => onTogglePopUp()}
        >
          {isAgendaAttachment ? (
            <Image src={AttachmentIcon} alt="Plus Icon" />
          ) : (
            <Image src={IconPlus} alt="Plus Icon" />
          )}
          <div className="add-file-text">
            {buttonTitle ? buttonTitle : "Add"}
          </div>
        </div>
      ) : null}

      {filesArr &&
        filesArr.map(value => {
          //let title = 'Issue_28.10.2021 - Letter to Principal Secretary Cum commissioner GNCTD- Budget allocation'; value.title = title;
          if (value && value !== undefined && Object.keys(value).length !== 0) {
            const extension = value.name.substr(
              value.name.lastIndexOf(".") + 1,
              value.name.length
            );
            const name = value.name.substr(0, value.name.lastIndexOf(".") - 1);
            let attachmentTitle;
            if (value.title !== null) {
              attachmentTitle =
                value.title.length > 20
                  ? value.title.substring(0, 20) + "..."
                  : value.title;
            } else {
              attachmentTitle =
                value.name.length > 20
                  ? value.name.substring(0, 20) + "..."
                  : value.name;
            }

            return (
              <div className="uploaded-file-wrapper">
                <div className="uploaded-file">
                  {removeRequired ? (
                    <div
                      className="remove-file"
                      onClick={() => onToogleRemovePopUp(value)}
                    />
                  ) : null}
                  <div className="file-detail">
                    <div>
                      {VIDEO_FORMATS.includes(extension) ? (
                        <div className="video-upload-icon" />
                      ) : (
                        <div className="upload-icon">
                          <span>{extension}</span>
                        </div>
                      )}
                    </div>
                    {!VIDEO_FORMATS.includes(extension) ? (
                      <>
                        <a target="_blank" href={value.s3Url}>
                          {/* {value.title || value.name} */}
                          {attachmentTitle}

                          {/* {(value.title.length > 20
                            ? value.title.substring(0, 20) + "..."
                            : value.title) ||
                            (value.name.length > 20
                              ? value.name.substring(0, 20) + "..."
                              : value.name)} */}
                        </a>
                        <div class="attachment-added-tooltip">
                          <div class="project-download-icons">
                            <div class="download-icons-pdf">{extension}</div>
                            <a
                              target="_blank"
                              href={value.s3Url}
                              download={value.title || value.name}
                              rel="noopener noreferrer"
                            >
                              {value.title || value.name}
                            </a>
                          </div>
                        </div>{" "}
                      </>
                    ) : (
                      <div
                        className="video-player pl-1"
                        onClick={() => {
                          setShowVideoModal(true);
                          setVideoUrl(value.s3Url);
                          setVideoTitle(value.title || value.name);
                        }}
                      >
                        {value.title || value.name}
                      </div>
                    )}
                    {showVideoModal === true && showVideoPlayerModal()}
                  </div>
                </div>
                {/* {!VIDEO_FORMATS.includes(extension) && (
                  <div class="attachment-added-tooltip">
                    <div class="project-download-icons">
                      <div class="download-icons-pdf">{extension}</div>
                      <a target="_blank" href={value.s3Url} download={value.title || value.name} rel="noopener noreferrer">{value.title || value.name}</a>
                    </div>
                  </div>
                )} */}
              </div>
            );
          }
        })}
    </section>
  );
}
